import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Agastya from "@/components/Agastya";
import SmoothScroll from "@/components/SmoothScroll";
import AnnouncementPopup from "@/components/AnnouncementPopup";

const Layout = () => {
  return (
    <SmoothScroll>
      <div className="min-h-screen bg-brand-cream text-brand-deep antialiased">
        <Header />
        <main className="pt-[calc(5rem+2.25rem)]">
          <Outlet />
        </main>
        <Footer />
        <Agastya />
        <AnnouncementPopup />
      </div>
    </SmoothScroll>
  );
};

export default Layout;
